const SUPABASE_URL =
  "https://ufbjibozwdsinnmlztxa.supabase.co";

const SUPABASE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVmYmppYm96d2RzaW5ubWx6dHhhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk3NjE1NDIsImV4cCI6MjA5NTMzNzU0Mn0.xNlvpDaf-RhTSyq2NUbLTlkYRuwrKCqO7oSWCEIwETU";

export async function getPortfolios() {
  const response = await fetch(
    `${SUPABASE_URL}/rest/v1/portofolio`,
    {
      method: "GET",
      headers: {
        apikey: SUPABASE_KEY,
        Authorization: `Bearer ${SUPABASE_KEY}`,
        "Content-Type": "application/json"
      }
    }
  );

  return response.json();
}

export async function getPortfolioById(id) {
  const response = await fetch(
    `${SUPABASE_URL}/rest/v1/portofolio?id=eq.${id}`,
    {
      method: "GET",
      headers: {
        apikey: SUPABASE_KEY,
        Authorization: `Bearer ${SUPABASE_KEY}`,
        "Content-Type": "application/json"
      }
    }
  );

  const data = await response.json();

  return data[0];
}